import React, { useState } from 'react'
import './Weightloss.css'
import Header from '../../Header/header'
import { RiArrowRightSLine } from 'react-icons/ri'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img2 from '../../../assets/doc_img2.webp'

const Weightloss = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqData = [
    {
      question: 'How Long Can You Stay?',
      answer: 'Yes, under the guidance of professionals, a safe and effective weight-loss treatment is well-conceived',
    },
    {
      question: 'Do I have to be on a diet to lose weight?',
      answer: 'Our plans are based on balanced nutrition and not extreme dieting, allowing you to keep transitory losses at bay.',
    },
    {
      question: 'Can I lose weight in a certain part of my body using weight-loss treatments under this model?',
      answer: 'Right, certain items disperse stubborn fat on the abdomen, thighs, and arms.',
    },
    {
      question: 'Is it necessary to have a consultation before treatment?',
      answer: 'Of course, if you have any questions about treatment and the effect shelter in your body, consult our experts',
    },
  ]

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='weighthero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Weight Loss
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Weight Loss Clinic in Pitampura | Safe Fat Loss Treatment | Sharva Clinic
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for a trusted weight loss clinic in Pitampura? Sharva Clinic offers personalized weight-loss programs, fat reduction
                treatments, and expert guidance for healthy and sustainable results.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Weight Loss Clinic in Pitampura – Sharva Clinic</h2>
              <p>
                If you&apos;re looking for a dependable weight loss clinic in Pitampura, then Sharva Clinic may be the place for you. Our innovative
                and personalized weight management programs aim to safely help you reach your own fitness and health goals. Sharva Clinic&apos;s
                expert team is committed to the provision of fact-based medication and lifestyle guidance. With our help, you can safely lose weight
                and improve your general quality of life.
              </p>
              <p>Excess body weight not only affects appearance but can also increase the risk of several health conditions, including:</p>
              <ul>
                <li>High blood pressure</li>
                <li>Diabetes</li>
                <li>Joint Pain</li>
                <li>Heart Problems</li>
                <li>Low energy levels</li>
                <li>Reduced metabolism</li>
              </ul>
              <p>
                At Sharva Clinic, a professional weight loss clinic in Pitampura, we can assist you with nutritional balancing, physician-guided fat
                loss treatments and more.
              </p>
              <p>
                Our expert team designs personalized diet plans tailored to work with your body type, lifestyle, and health goals. Only through this
                approach will your weight loss be effective and sustainable.
              </p>
              <p>Advanced fat reduction procedures help target troublesome fatty areas that are hard to reduce with exercise alone.</p>
              <p>
                Obviously, Healthy lifestyle changes in combination with regular physical activity can boost the metabolism and promote long-term
                management of weight.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Why Choose Sharva Clinic to Lose Weight in Pitampura?</h3>
              <p>Founded on a doctor-patient interactive model, Sharva Clinic is known for providing high-level aesthetic and wellness treatments.</p>
              <p>Patients choose Sharva Clinic because of:</p>
              <ul>
                <li>Healthcare professionals with experience</li>
                <li>Customized treatment plans tailored to each patient&apos;s needs</li>
                <li>Advanced technology and procedures</li>
                <li>A hygienic, safe clinic environment</li>
                <li>Weight loss that is natural and healthy</li>
              </ul>
              <h3 style={{ fontSize: '23px', marginTop: '16px' }}>Continuous Advice and Help</h3>
              <p>
                We believe patients lose weight most successfully when doctors combine medical knowledge with improved living habits and individual
                attention.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Who Can Benefit from Weight Loss Treatment?</h3>
              <p>You might be able to benefit from a weight loss clinic in Pitampura if you:</p>
              <ul>
                <li>Are fighting stubborn fat</li>
                <li>Would like to lose weight safely and effectively</li>
                <li>Fail to lose weight through diet and exercise alone</li>
                <li>Desire professional help with healthy weight management</li>
                <li>Are seeking non-surgical fat reduction choices</li>
              </ul>
              <p>
                After examining your health status and lifestyle, Sharva Clinic will be able to decide the most suitable weight loss program for you
                and your health targets.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What to Expect During Your Consultation</h3>
              <p>When you visit Sharva Clinic for weight loss treatment, our doctors hire specialists to scrutinize:</p>
              <ul>
                <li>Your health and the way you live</li>
                <li>Your body composition and what your weight goal should be</li>
                <li>Factors responsible for your putting on weight</li>
                <li>Personalized weight management plan</li>
                <li>Continuous help and monitoring</li>
              </ul>
              <p>This combination can ensure successful results in both the short-term and long-term.</p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Gaurav Pandey'
              specialty='Diabetologist & Chest Specialist'
              education='MD Pulmonary Medicine, CDM (Diabetes), Spl. Int. - Diabetes & Hypertension'
              image={doc_img2}
              blurb='Dr. Gaurav Pandey designs medically supervised weight management plans at Sharva Clinique, factoring in metabolic health, diabetes risk, and lifestyle.'
              profileLink='/drgaurav/diabetes'
            />

            <div className='faq-list'>
              <h3 style={{ fontSize: '23px' }}>FAQs - Weight-Loss Clinic in Pitampura</h3>
              {faqData.map((item, index) => (
                <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                  <div className='faq-question' onClick={() => toggleFAQ(index)}>
                    <h3>{item.question}</h3>
                    <span className='faq-icon'>{activeIndex === index ? '−' : '+'}</span>
                  </div>

                  <div className='faq-answer-wrapper'>
                    <div className='faq-answer'>
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='asthmareview'>
          <p
            className=''
            style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#85553D',
              fontFamily: 'inherit',
            }}
          >
            What Our Patients Say
          </p>
          <div className='card1'>
            <p>“I lost 18 kg in 5 months with their customized plan. The coaches were always supportive and helped me stay motivated.”</p>
            <p> — Amit </p>
          </div>
          <div className='card2'>
            <p>“The nutrition guidance was easy to follow and fit my lifestyle. I saw real changes without feeling restricted.”</p>
            <p>— Rohit </p>
          </div>
          <div className='card3'>
            <p>“The personalized approach made all the difference. I’ve kept the weight off and adopted healthier habits for life.”</p>
            <p> — Khushi</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Weightloss
